<template>
  <!-- Weiße Insel auf dem Seitengrund. Styles zentral in theme/utils.scss (.page-island).
       .surface-light: Suchfelder darin werden hellgrau statt weiß-auf-weiß. -->
  <section
    class="page-island surface-light"
    :class="{'page-island--fill': fill}"
  >
    <header
      v-if="hasHead"
      class="page-island__head"
    >
      <div
        v-if="hasTitleRow"
        class="page-island__title-row"
      >
        <div>
          <h2
            v-if="title"
            class="page-island__title"
          >
            {{ title }}
          </h2>
          <p
            v-if="subtitle"
            class="page-island__subtitle"
          >
            {{ subtitle }}
          </p>
        </div>
        <div
          v-if="$slots.actions"
          class="page-island__actions"
        >
          <slot name="actions" />
        </div>
      </div>
      <slot name="toolbar" />
    </header>

    <!-- Bei `fill` ist der Body der Scroll-Host der Seite (ion-refresher, ion-infinite-scroll). -->
    <div
      class="page-island__body"
      :class="{'ion-content-scroll-host': fill}"
    >
      <slot />
    </div>

    <footer
      v-if="$slots.footer"
      class="page-island__footer"
    >
      <slot name="footer" />
    </footer>
  </section>
</template>

<script>
export default {
    name: 'PageIsland',
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        /**
         * Insel füllt die Höhe der Seite (BaseLayout `fill`): Kopf und Toolbar
         * bleiben stehen, nur der Body scrollt. Die Insel dann nicht per v-if
         * ein-/ausblenden, sonst findet der Refresher beim Mount keinen Scroll-Host.
         */
        fill: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasTitleRow() {
            return !!(this.title || this.subtitle || this.$slots.actions);
        },
        hasHead() {
            return this.hasTitleRow || !!this.$slots.toolbar;
        },
    },
};
</script>
